export function useCustomFlagFormatter() {
  /**
   * Formats a custom flag value for display
   * @param {*} value - The custom flag value to format
   * @returns {string} - "Yes" for truthy values, "No" for falsy values
   */
  const formatCustomFlag = value => {
    if (value === true) {
      return 'Yes';
    }
    return 'No';
  };
  return {
    formatCustomFlag
  };
}